<template>
  <!-- 商品新增/编辑 -->
  <div class="addProduct">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 商品表单 -->
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <el-form
        :model="goodForm"
        label-position="rigth"
        label-width="120px"
        :rules="goodFormRule"
        ref="addForm"
      >
        <div class="form-item-wrap">
          <el-form-item label="商品名称" prop="goodsName">
            <el-input
              class="form-input"
              v-model="goodForm.goodsName"
              disabled
              style="width: 200px"
            >
            </el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="商品封面图" prop="">
            <!-- 图片预览组件，洛奥的开启了清除功能 -->
            <img-view
              :isDelete="coverImg != ''"
              :imgList="[{ url: coverImg, id: 0 }]"
              @handleDel="coverImg = ''"
            ></img-view>
            <!-- 文件上传组件 -->
            <upload
              @fileChange="uploadCover"
              accept="image/jpg,image/jpeg,image/png"
            >
            </upload>
            <div>
              “带宽”决定了界面加载速度，为了保证用户体验和App性能，请使用小于40KB图像作为封面图
            </div>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="商品摘要" prop="zhaiyao">
            <el-input
              class="form-input"
              v-model="goodForm.zhaiyao"
              clearable
              style="width: 700px"
            >
            </el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="商品详情图" prop="">
            <div class="imgInfoView">
              <div
                class="imgInfo"
                v-for="(item, index) in slideList"
                :key="index"
              >
                <img-view
                  :imgList="[{ url: item.img, id: 0 }]"
                  :isDelete="true"
                  @handleDel="delGoodsImg(item)"
                >
                </img-view>
                <div class="imgIngoSort">
                  <span>排序：</span>
                  <el-input-number
                    v-model="item.sort"
                    :min="1"
                    style="width: 110px"
                    @change="saveGoodsImg(item)"
                  >
                  </el-input-number>
                </div>
              </div>
              <upload
                @fileChange="uploadGoods"
                accept="image/jpg,image/jpeg,image/png"
                :multiple="true"
              ></upload>
            </div>
          </el-form-item>
        </div>

        <div class="form-item-wrap">
          <el-form-item label="商品说明书" prop="des">
            <!-- <wang-editor :value="goodForm.des" @change="change" style="width: 700px;"></wang-editor> -->
            <tinymce
              :value="goodForm.des"
              @input="change"
              :isEditorLoad="isEditorLoad"
            ></tinymce>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="">
            <el-button type="primary" @click="submitForm">保存</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
    <!-- 修改价格弹窗 -->
    <el-drawer
      :visible.sync="isModifyPrice"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">修改价格</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="priceForm"
            label-position="rigth"
            label-width="100px"
            :rules="priceRule"
            ref="priceForm"
          >
            <!-- <el-form-item label="供货价" prop="supplyPrice">
            <el-input v-model="priceForm.supplyPrice"></el-input>
          </el-form-item> -->
            <el-form-item label="价格等级" prop="name">
              <el-input v-model="priceForm.name" readonly></el-input>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input v-model="priceForm.price"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="priceSubmit">确定</el-button>
        <el-button type="info" @click="priceClear">取消</el-button>
      </div>
    </el-drawer>

    <!-- 数据选择 -->
    <tableDialog
      v-if="dialogVisible"
      :title="'商品标签'"
      :isMoreSel="true"
      :searchValue="searchForm.name"
      :tableData="tableList"
      :tableHead="tableDataHead"
      :currPage.sync="currPage"
      :pageSize.sync="pageSizeData"
      :allPage="allPage"
      @search="getTagList"
      @rowClick="rowClick"
      @moreSel="selDataOk"
      @hanCurrChange="hanCurrChange"
      @hanSizesChange="hanSizesChange"
      @close="dialogVisible = false"
    >
    </tableDialog>
  </div>
</template>

<script>
//组件
// import WangEditor from "@/components/WangEditor.vue";
import Tinymce from "@/components/Tinymce";
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "addImgProduct",
  data() {
    return {
      /**接收到商品id */
      goodsId: null,
      /**商品表单 */
      //商品分类 商品楼层 价格 品牌 描述 排序 封面图 商品详情图
      goodForm: {
        articleId: "", // 商品ID
        entId: "", // 机构ID
        classify: "", // 商品分类
        floor: [], // 首页楼层
        goodsName: "", // 商品名称
        mnemonicCode: "", // 助记码
        generic: "", // 通用名
        drugSpec: "", // 商品规格
        packageUnit: "", // 包装单位
        valdate: "", // 包装单位
        minPackage: 1, // 中包装
        bigPackage: 0, // 大包装
        drugFactory: "", // 生产厂家
        approvalNumber: "", // 批准文号
        dosageForm: "", // 剂型
        category: "", //类别
        storageConditions: "", //储存条件
        price: "", // 商品价格
        isZbz: "N", // 是否中包装控制
        isDbz: "N", // 是否大包装控制
        // isLimit: "N", // 是否限购
        // limitNum: 0, // 限购数量
        // kxType: "日期", //限购类型 日期/间隔天数
        // kxDay: 0, //限购类型间隔天数值
        // limitTime: [], // 限购时间
        cover: "", // 封面图片
        sort: 1, // 排序值
        tags: "", // 功能主治
        zhaiyao: "", // 商品摘要
        des: "", // 商品详情
        cflx: "", //处方类型
        yb: false, //是否医保
        warningNum: 0, //库存预警
        scatteredPackage: 1, //最低购买数量(标准商城新增)
        IsKcNoUpdate: "Y", //是否库存同步
        stockQuantity: 0, //库存数量
        IsJgNoUpdate: "Y", // 是否同步价格
        promQuantity: 0, //赠品/换购商品数量
      },
      goodFormRule: {
        classify: [mustFill],
        goodsName: [mustFill],
        drugSpec: [mustFill],
        packageUnit: [mustFill],
        minPackage: [mustFill],
        bigPackage: [mustFill],
        drugFactory: [mustFill],
        approvalNumber: [mustFill],
        // limitNum: [this.limitMustFill()],
        // limitTime: [this.limitMustFill()],
        scatteredPackage: [mustFill],
      },
      // 商品标签列表
      tagList: [],
      /**存放封面图img临时地址 */
      coverImg: "",
      /**存放商品详情图 */
      slideList: [],
      /**分类列表 */
      classifyList: [],
      /**楼层列表选项 */
      floorList: [],
      // 价格相关
      priceList: [],
      isModifyPrice: false,
      priceForm: {
        code: "",
        name: "",
        price: "",
      },
      priceRule: {
        supplyPrice: [mustFill],
        price: [mustFill],
      },
      isEditorLoad: false, // 编辑器是否加载完成
      // 现在商品标签相关
      dialogVisible: false,
      currPage: 1,
      pageSizeData: 10,
      allPage: 0,
      isSelDataOkRep: false,
      searchForm: {
        name: "",
      },
      tableList: [],
      tableDataHead: {},
    };
  },
  components: {
    Tinymce,
  },
  mounted() {
    //接收role传递参数
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams) {
      //执行编辑，没有注册
      this.goodsId = prams.goodsId;
      this.getGoodData();
      this.getClassify();
      this.getDetailImg();
    }
  },
  computed: {
    /**返回详情图片地址 */
    viewSlideList() {
      return this.slideList.map((item) => {
        return item.url;
      });
    },
  },
  methods: {
    /**返回 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    /**获取商品详情 */
    getGoodData(isOnlyPrice) {
      let data = {
        type: "GetGoodsDetail",
        strWhere: this.goodsId,
      };
      let proc = "Proc_Admin_GoodsList"; // 存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          //新改的接口
          // let data = {
          //   entId: window.localStorage.getItem("entId"),
          //   userId: window.localStorage.getItem("userId"),
          //   articleId: this.goodsId,
          // };
          // this.$request({
          //   url: "Goods/ApiGoodsDetails",
          //   method: "post",
          //   data,
          // })
          // .then((res) => {
          // console.log(res);
          if (res.flag == 0) {
            if (isOnlyPrice) {
              // this.getPriceLevel(res.table1 || [])
              this.priceList = (res.table1 || []).map((item) => {
                return {
                  code: item.pricelevel,
                  name: item.pricelevel,
                  title: item.PriceName,
                  price: item.price,
                };
              });
              return;
            }

            try {
              this.goodForm.articleId = res.table0[0].article_id;
              this.goodForm.entId = res.table0[0].entid;
              this.goodForm.classify = res.table0[0].category_id;
              this.goodForm.floor = (res.table3 || []).map((item) => {
                return item.id;
              });
              this.goodForm.goodsName = res.table0[0].sub_title;
              this.goodForm.mnemonicCode = res.table0[0].mnemonic_code;
              this.goodForm.generic = res.table0[0].generic;
              this.goodForm.drugSpec = res.table0[0].drug_spec;
              this.goodForm.packageUnit = res.table0[0].package_unit;
              this.goodForm.valdate = res.table0[0].valdate;
              this.goodForm.minPackage = parseInt(res.table0[0].min_package); // 中包装转换为数字
              this.goodForm.bigPackage = parseInt(res.table0[0].big_package);
              this.goodForm.isZbz = res.table0[0].scattered;
              this.goodForm.isDbz = res.table0[0].packControl;
              this.goodForm.drugFactory = res.table0[0].drug_factory;
              this.goodForm.approvalNumber = res.table0[0].approval_number;
              this.goodForm.dosageForm = res.table0[0].dosage_form;
              this.goodForm.category = res.table0[0].category;
              this.goodForm.storageConditions =
                res.table0[0].Storage_conditions;
              this.goodForm.price = res.table0[0].price; // 商品推荐价格
              // this.goodForm.isLimit = res.table0[0].isXgKz;
              // this.goodForm.limitNum = res.table0[0].ControlNum;
              // this.goodForm.kxType = res.table0[0].KxType
              //   ? res.table0[0].KxType
              //   : "日期"; // 可能为空，如果为空则默认日期
              // this.goodForm.kxDay = res.table0[0].KxDay
              //   ? parseInt(res.table0[0].KxDay)
              // : 0; // 如果不设置默认返回的空，所以加了判断
              // this.goodForm.limitTime = [
              //   res.table0[0].startTime,
              //   res.table0[0].endTime,
              // ];
              this.goodForm.des = decodeURIComponent(
                atob(res.table0[0].content)
              );
              this.tagList = res.table0[0].label
                .split(",")
                .filter((item) => item);
              this.isEditorLoad = true;
              this.goodForm.sort = res.table0[0].sort_id || 1;
              this.coverImg = this.$setImgUrl(res.table0[0].img_url);
              this.goodForm.cover = res.table0[0].img_url;
              this.goodForm.tags = res.table0[0].tags;
              this.goodForm.zhaiyao = res.table0[0].zhaiyao;
              this.goodForm.cflx = res.table0[0].PrescriptionType;
              this.goodForm.yb = res.table0[0].IsYb == "Y";
              this.goodForm.warningNum = parseInt(res.table0[0].WarningNum);
              // 最小限购数量不小于中包装数量
              this.goodForm.scatteredPackage = parseInt(
                res.table0[0].scatteredPackage
              ); //最小限购数量
              if (this.goodForm.minPackage > this.goodForm.scatteredPackage) {
                this.goodForm.scatteredPackage = this.goodForm.minPackage; //最小限购数量
              }

              this.goodForm.IsKcNoUpdate = res.table0[0].IsKcNoUpdate; // 是否同步库存
              // 这里判断一下该字段
              if (res.table0[0].stock_quantity) {
                this.goodForm.stockQuantity = parseInt(
                  res.table0[0].stock_quantity
                ); // 是否同步库存
              }
              this.goodForm.IsJgNoUpdate = res.table0[0].IsJgNoUpdate; // 是否同步价格
              this.goodForm.promQuantity = parseInt(res.table0[0].PromQuantity); //赠品/换购商品数量
            } catch (error) {
              console.log(error);
            }

            // this.getPriceLevel(res.table1 || [])
            this.priceList = (res.table1 || []).map((item) => {
              return {
                code: item.pricelevel,
                name: item.pricelevel,
                title: item.PriceName,
                price: item.price,
              };
            });
            return;
          } else {
            this.$message({
              message: "获取详情失败",
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取商品价格级别
    getPriceLevel(list) {
      let data = {
        entId: window.localStorage.getItem("entId"),
        searchVal: "",
        pageIndex: 1,
        pageSize: 9999999,
      };
      this.$request({
        method: "post",
        url: "Goods/GetPriceLevel",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            let priceList = (res.list || []).map((item) => {
              return {
                code: item.PriceCode,
                name: item.PriceName,
                price: 0,
              };
            });
            let priceData = this.$arrToObj(list, "pricelevel");
            for (let i = 0; i < priceList.length; i++) {
              let item = priceList[i];
              item.price =
                (priceData[item.code] && priceData[item.code].price) || 0;
            }
            this.priceList = priceList;
            // console.log(priceList, priceData);
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**获取商品详情图 */
    getDetailImg() {
      var proc = "Proc_Admin_Img"; // 存储过程名
      var type = "ReturnList";
      var data = {
        type: "Pc_GetProductImg",
        strWhere: "",
        article_id: this.goodsId,
        PageIndex: 1,
        PageSize: 15,
      };
      this.$requestSys({
        url:
          "main/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      }).then((res) => {
        this.slideList = [];
        if (res.flag == 0) {
          res.data.forEach((item) => {
            this.slideList.push({
              id: item.Id,
              img: this.$setImgUrl(item.img_url),
              url: item.img_url,
              sort: item.sort_id,
            });
          });
        }
      });
    },
    /**获取商品分类数据 */
    getClassify() {
      let data = {
        type: "GoodsAttributeBox",
      };
      let proc = "Proc_Admin_GoodsList"; //存储过程名
      let type = "LoadCheckBox";
      this.$requestSys({
        url:
          "goods/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.floorList = this.changeArr(res.attributeList);
            this.classifyList = this.changeArr(res.categoryList);
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    //数组转化
    changeArr(list) {
      list = list.split("</option><option");
      list = list.map((item) => {
        let label = item
          .split("'>")[1]
          .split("</option>")[0]
          .replace(/&nbsp;/g, " ");
        let value = item.split("value='")[1].split("'>")[0];
        return { label, value };
      });
      return list;
    },
    getTagList(val, isRep) {
      this.searchForm.name = isRep ? val : this.searchForm.name;
      let data = {
        entId: window.localStorage.getItem("entId"),
        navType: "GoodsTag",
        status: 2,
      };
      this.$request({
        method: "post",
        url: "Navigation/GetNavigationAll",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.tableList = res.list || [];
            this.tableDataHead = { Id: "编号", title: "名称", sort_id: "排序" };
            this.allPage = (res.list || []).length;
            this.dialogVisible = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTagList();
    },
    /**当前页改变 */
    hanSizesChange(val) {
      this.pageSizeData = val;
      this.getTagList();
    },
    // 选择单条数据
    rowClick(row, isSelDataOk) {
      for (let i = 0; i < this.tagList.length; i++) {
        if (this.tagList[i] == row.title) {
          if (isSelDataOk === true) {
            this.isSelDataOkRep = true;
          } else {
            this.$message({
              message: "选择的数据已在列表中",
              type: "warning",
            });
          }
          return;
        }
      }
      this.tagList.push(row.title);
      this.dialogVisible = false;
    },
    // 选择数据完成，多选
    selDataOk(selectedList) {
      if (selectedList.length == 0) {
        this.$message({
          message: "请选择数据",
          type: "warning",
        });
        return;
      }
      selectedList.forEach((item) => {
        this.rowClick(item, true);
      });
      if (this.isSelDataOkRep) {
        this.$message({
          message: "选择的数据已在列表中",
          type: "warning",
        });
        this.isSelDataOkRep = false;
      }
    },
    // 标签删除
    tagClose(index) {
      this.tagList.splice(index, 1);
    },
    // 限购表单控制
    // limitMustFill() {
    //   return {
    //     validator: (rule, value, callback) => {
    //       if (this.goodForm.isLimit == "Y") {
    //         if (!value) {
    //           return callback(new Error("该字段为必填项"));
    //         } else {
    //           return callback();
    //         }
    //       } else {
    //         return callback();
    //       }
    //     },
    //   };
    // },
    // 修改价格
    modifyPrice(row) {
      this.priceClear();
      this.priceForm.code = row.code;
      this.priceForm.name = row.name;
      this.priceForm.price = row.price;
      this.isModifyPrice = true;
    },
    // 关闭设置优惠券金额弹窗
    priceClear() {
      for (let key in this.priceForm) {
        this.priceForm[key] = "";
      }
      this.isModifyPrice = false;
    },
    // 优惠券金额修改提交
    priceSubmit() {
      this.$refs["priceForm"].validate((valid) => {
        if (valid) {
          let data = {
            entId: window.localStorage.getItem("entId"),
            articleId: this.goodsId,
            pricelevel: this.priceForm.code,
            discountPrice: 0,
            price: this.priceForm.price,
          };
          this.$request({
            url: "GoodsAdmin/UpdateGoodsPrice",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.priceClear();
              this.getGoodData(true);
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        }
      });
    },
    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          var data = {
            article_id: this.goodForm.articleId,
            entId: this.goodForm.entId,
            category_id: this.goodForm.classify,
            sub_title: this.goodForm.goodsName,
            sort_id: this.goodForm.sort,
            mnemonic_code: this.goodForm.mnemonicCode,
            generic: this.goodForm.generic,
            drug_spec: this.goodForm.drugSpec,
            package_unit: this.goodForm.packageUnit,
            min_package: this.goodForm.minPackage + "", //转换为字符串
            big_package: this.goodForm.bigPackage + "",
            drug_factory: this.goodForm.drugFactory,
            approval_number: this.goodForm.approvalNumber,
            dosage_form: this.goodForm.dosageForm,
            category: this.goodForm.category,
            Storage_conditions: this.goodForm.storageConditions,
            rate: "0",
            price: this.goodForm.price,
            brand_img_url: "",
            img_url: this.goodForm.cover,
            left_pic: "",
            min_package_astrict: "N",
            content: btoa(encodeURIComponent(this.goodForm.des)),
            recommendList: this.goodForm.floor.join(","),
            BrandCode: "",
            isZbz: this.goodForm.isZbz,
            isDbz: this.goodForm.isDbz,
            // isXgKz: this.goodForm.isLimit,
            // ControlNum: this.goodForm.limitNum,
            // kxType: this.goodForm.isLimit == "Y" ? this.goodForm.kxType : "", //控销类型日期还是间隔天数
            // kxDay:
            //   this.goodForm.isLimit == "Y" && this.goodForm.kxType == "间隔天数"
            //     ? this.goodForm.kxDay
            //     : "", // 间隔几天
            // startTime:
            //   this.goodForm.isLimit == "Y" && this.goodForm.kxType == "日期"
            //     ? this.goodForm.limitTime[0]
            //     : "",
            // endTime:
            //   this.goodForm.isLimit == "Y" && this.goodForm.kxType == "日期"
            //     ? this.goodForm.limitTime[1]
            //     : "",
            tags: this.goodForm.tags,
            zhaiyao: this.goodForm.zhaiyao,
            label: this.tagList.length ? this.tagList.join(",") + "," : "",
            prescriptionType: this.goodForm.cflx, //
            isYb: this.goodForm.yb ? "Y" : "N", //是否医保
            warningNum: this.goodForm.warningNum, //是否医保
            promQuantity: this.goodForm.promQuantity, // 活动数量
            // IsKcNoUpdate: this.goodForm.IsKcNoUpdate, // 是否同步库存
            // stockQuantity: this.goodForm.stockQuantity, //如果没有同步库存传入库存数量
            // IsJgNoUpdate: this.goodForm.IsJgNoUpdate, //是否同步价格
          };
          this.$request({
            // url: "Goods/UpdateProduct",
            url: "/Management/GoodsAdmin/EditGoodsDetail", //标准商城新加的接口
            method: "post",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.goBack();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
    /**封面图片文件上传回调 */
    uploadCover(file) {
      if (file.length) {
        //将上传的图片file对象直接转化为blob地址，无需重新获取商品详情
        this.coverImg = URL.createObjectURL(file[0]);
        let fileData = new FormData();
        for (let i = 0; i < file.length; i++) {
          fileData.append("goodsfile", file[i]);
        }
        let type = "goods";
        this.$uploadRequest({
          url: "admin/ashx/UploadImg.ashx?type=UploadImage&imgType=" + type,
          method: "post",
          data: fileData,
        })
          .then((res) => {
            if (res.flag == 0) {
              this.goodForm.cover = res.message;
              this.$message({
                message: "图片上传成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },
    // 商品详情图片上传回调
    uploadGoods(file) {
      if (file.length) {
        let fileData = new FormData();
        for (let i = 0; i < file.length; i++) {
          fileData.append("goodsfile", file[i]);
        }

        // 这个是新添加的接口
        this.$uploadRequest({
          method: "post",
          url:
            "/Management/GoodsAdmin/UpLoadGoosImgApi?articleId=" + this.goodsId,
          data: fileData,
        })
          .then((res) => {
            if (res.success) {
              this.getDetailImg();
              this.$message({
                message: res.message,
                type: "success",
              });

              // 如果dataModel返回的有值，则将封面图给替换了
              if (res.dataModel) {
                this.coverImg = this.$setImgUrl(res.dataModel);
              }
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });

        // let type = "UploadGoodsImgList";
        // this.$uploadRequest({
        //   url:
        //     "admin/ashx/UploadImg.ashx?imgType=goods&type=" +
        //     type +
        //     "&articleId=" +
        //     this.goodForm.articleId +
        //     "&entId=" +
        //     this.goodForm.entId,
        //   method: "post",
        //   data: fileData,
        // })
        //   .then((res) => {
        //     if (res.flag == 0) {
        //       // this.saveGoodsImg({url: res.message})
        //       this.getDetailImg();
        //       this.$message({
        //         message: "上传成功",
        //         type: "success",
        //       });
        //     } else {
        //       this.$message({
        //         message: res.message,
        //         type: "error",
        //       });
        //     }
        //   })
        //   .catch((err) => {
        //     window.console.log(err);
        //   });
      }
    },
    // 保存商品详情图片
    saveGoodsImg(item) {
      let data = {
        type: "Pc_SetProductImg",
        article_id: this.goodsId,
        id: item.id,
        sort_id: item.sort,
      };
      let proc = "Proc_Admin_Img"; // 存储过程名
      let type = "ReturnNumber";
      this.$requestSys({
        url:
          "main/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.getDetailImg();
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**删除详情图片 */
    delGoodsImg(item) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          var data = {
            type: "PC_DelProImg",
            strWhere: item.id,
          };
          var proc = "Proc_Admin_Img"; // 存储过程名
          var type = "ReturnNumber";
          this.$requestSys({
            url:
              "coupon/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getDetailImg();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    /**富文本编辑内容改变回调 */
    change(val) {
      this.goodForm.des = val;
    },
  },
};
</script>

<style scoped>
.addProduct {
  width: 100%;
  height: 100%;
}

.imgInfoView {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.imgInfo {
  display: inline-block;
  width: 160px;
  text-align: center;
}

.imgIngoSort {
  margin-bottom: 10px;
}
</style>
